import React, {useMemo, useEffect} from 'react';
import {Box, IconButton, Typography} from '@material-ui/core';
import {Pagination, Table} from 'antd';
import CurrencyFormat from 'react-currency-format';
import {useDispatch, useSelector} from 'react-redux';
import {SELECTOR_COMPANIES_BUDGETS, SELECTOR_COMPANIES_BUDGETS_TOTALS} from '../../redux/selectors/companiesBudgets';
import {getCompaniesBudgets, deleteCompanyBudget} from '../../redux/actions/companiesBudgets';
import {Edit as EditIcon, Delete as DeleteIcon, PersonAdd as PersonAddIcon} from '@material-ui/icons';

export default function BudgetsTable({onEdit, onManageUsers}) {
  const companiesBudgets = useSelector(SELECTOR_COMPANIES_BUDGETS);
  const pagination = useSelector(SELECTOR_COMPANIES_BUDGETS_TOTALS);

  const dispatch = useDispatch();

  const columns = useMemo(
    () => [
      {
        title: 'Centro de costo',
        dataIndex: 'cost_center',
      },
      {
        title: 'Cuenta mayor',
        dataIndex: 'major_account',
      },
      {
        title: 'Presupuesto',
        dataIndex: 'budget',
        render: (budget) => (
          <CurrencyFormat
            value={budget}
            displayType="text"
            thousandSeparator
            prefix="$"
            renderText={(value) => <span>{value}</span>}
          />
        ),
      },
      {
        render: (data) =>(
          <Box display="flex" alignItems="center">
            <IconButton size="small" onClick={() => onManageUsers(data.id)}>
              <PersonAddIcon />
            </IconButton>
            <IconButton size="small" onClick={() => onEdit(data)}>
              <EditIcon color="primary" />
            </IconButton>
            <IconButton size="small" onClick={() => _deleteCompanyBudget(data.id)}>
              <DeleteIcon color="error" />
            </IconButton>
          </Box>
        ),
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  function _getCompaniesBudgetData(skip) {
    dispatch(getCompaniesBudgets({query: {$skip: skip}}));
  }

  function _deleteCompanyBudget(id) {
    dispatch(deleteCompanyBudget(id));
  }

  useEffect(() => {
    _getCompaniesBudgetData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      {!companiesBudgets.length && (
        <Box mt={2}>
          <Typography variant="caption">No hay presupuestos registrados</Typography>
        </Box>
      )}
      {!!companiesBudgets.length && (
        <>
          <Table columns={columns} rowKey={(item) => item.id} dataSource={companiesBudgets} pagination={false} />
          <div style={{display: 'flex', justifyContent: 'flex-end', paddingTop: 5}}>
            <Pagination
              defaultCurrent={1}
              total={pagination.total}
              showSizeChanger={false}
              defaultPageSize={10}
              onChange={(current, pageSize) => {
                _getCompaniesBudgetData((current - 1) * pageSize);
              }}
            />
          </div>
        </>
      )}
    </div>
  );
}
